import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './offerMetaData.css';

interface IOfferMetaDataProps {
  updated: string;
  stats: React.ReactElement;

  values: React.ReactElement;
  promotionDescription: React.ReactElement;
  isInHiddenBase: boolean;
}

export const OfferMetaData = ({
  updated,
  stats,
  values,
  isInHiddenBase,
  promotionDescription,
}: React.PropsWithChildren<IOfferMetaDataProps>) => {
  return (
    <div className={styles['container']}>
      <div className={styles['item']}>
        <div data-testid="metadata-updated-date" className={styles['updated']}>
          <UIText2 color="text-primary-disabled">{updated}</UIText2>
        </div>
        <div className={styles['stats']}>{stats}</div>
      </div>
      <div className={styles['item']}>
        <div className={styles['values']}>
          {values}
          {promotionDescription}
        </div>
        {isInHiddenBase && <div className={styles['in_hidden_base']}>Видят только агенты</div>}
      </div>
    </div>
  );
};
